<ui-object-navigation-main-page alias="cm"></ui-object-navigation-main-page>